import { Text } from '@loomhq/lens';
import _debounce from 'lodash/debounce';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { showConfirmationModal } from 'actions/confirmationModal';
import { endCTAFlow } from 'actions/editor';
import {
  updateVideoCtaEnabled,
  updateVideoCtaModalShow,
  updateVideoCtaMods,
  updateVideoCtaText,
  updateVideoCtaUrl,
} from 'actions/shareVideo';
import {
  requestVideoPlayerCurrentTime,
  requestVideoPlayerPause,
  requestVideoPlayerPlay,
  updateVideoPlayerPlaying,
} from 'actions/videoPlayer';
import {
  CALL_OUT_PURPLE,
  NEW_INFO_BLUE,
  NEW_SUCCESS_GREEN,
  NEW_WARNING_YELLOW,
  PRIMARY_TEXT_BLACK,
  SALMON,
  WHITE,
} from 'constants/colors';
import { ADD_CUSTOM_VIDEO_CTA_ENABLED } from 'constants/events';
import { clearCTAWidgetState, saveCTA } from 'creators/editor';
import { updateVideoCtaCreator } from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';

import dropdownIconRP from 'img/icons/new/dropdown-rp.png';
import dropdownIcon from 'img/icons/new/dropdown.png';
import rCorner from 'img/icons/new/rounded-corner.svg';
import srCorner from 'img/icons/new/slightly-rounded-corner.svg';
import sqCorner from 'img/icons/new/square-corner.svg';
import trashcanE from 'img/icons/new/trash.svg';
import rainbowSrc from 'img/rainbow-oval.png';

import { isHexColor, urlRegex } from '../../../../../shared/validate';

import Button from 'components/ui-components/button';
import ColorPicker from 'components/ui-components/color-picker';
import Dropdown from 'components/ui-components/dropdown';
import Input from 'components/ui-components/input';

import './styles.less';

const CORNER_STYLE_ROUNDED = 25;

const CORNER_STYLE_SQUARED = 0;

const CORNER_STYLE_SLIGHTLY_ROUNDED = 4;

const PRESET_COLORS = [
  SALMON,
  NEW_WARNING_YELLOW,
  NEW_SUCCESS_GREEN,
  NEW_INFO_BLUE,
  CALL_OUT_PURPLE,
  WHITE,
  PRIMARY_TEXT_BLACK,
];

class CTAForm extends Component {
  state = {
    corner_dropdown: false,
    bg_color_picker: false,
    text_color_picker: false,
    text_color_err: false,
    background_color_err: false,
    url_err: false,
    return_to_time: null,
  };

  render() {
    const {
      corner_dropdown,
      bg_color_picker,
      text_color_picker,
      text_color_err,
      background_color_err,
      url_err,
    } = this.state;

    const { ctaEnabled, ctaText, ctaUrl, ctaMods } = this.props;

    const saveEligible = this.saveEligible();

    return (
      <div className="cta-form">
        <Text variant="title">Create a call-to-action</Text>
        <Input
          autoFocus={true}
          onChange={button_text => this.handleCtaTextInput(button_text)}
          fieldLabel="Button text"
          inputClass="new-style"
          fieldId="button-text"
          fieldValue={ctaText}
          isRequired={false}
        />
        <Input
          inputClass="new-style"
          onBlur={this.instantValidate}
          onChange={button_link => this.handleCtaUrlInput(button_link)}
          fieldLabel="Button link (URL)"
          fieldId="button-link"
          status={url_err ? 'Yikes! Doesn’t look like a valid URL' : null}
          severity={url_err ? 'error' : null}
          fieldValue={ctaUrl}
          isRequired={false}
        />
        <div
          className="picker-input"
          onClick={() =>
            this.setState({
              text_color_picker: false,
              bg_color_picker: true,
              corner_dropdown: false,
            })
          }
        >
          <Input
            inputClass="new-style"
            onChange={button_color =>
              this.handleCtaBackgroundColorInput(button_color)
            }
            onFocus={() =>
              this.setState({
                text_color_picker: false,
                bg_color_picker: true,
                corner_dropdown: false,
              })
            }
            onBlur={() => this.setState({ bg_color_picker: false })}
            fieldLabel="Button color"
            fieldId="button-color"
            status={
              background_color_err
                ? 'Yikes! Doesn’t look like a valid color'
                : null
            }
            severity={background_color_err ? 'error' : null}
            type="color"
            fieldValue={(ctaMods || {}).background_color}
            isRequired={false}
          />
          <img
            src={rainbowSrc}
            className="picker-icon"
            onClick={() => document.getElementById('button-color').focus()}
          />
          <div className="form-color-picker">
            <ColorPicker
              onClickOutside={() => this.setState({ bg_color_picker: false })}
              show={bg_color_picker}
              disableAlpha={true}
              presetColors={PRESET_COLORS}
              color={(ctaMods || {}).background_color}
              onChangeComplete={color =>
                this.handleCtaBackgroundColorInput(color.hex)
              }
            />
          </div>
        </div>
        <div
          className="picker-input"
          onClick={() =>
            this.setState({
              text_color_picker: true,
              bg_color_picker: false,
              corner_dropdown: false,
            })
          }
        >
          <Input
            inputClass="new-style"
            onChange={text_color => this.handleCtaTextColorInput(text_color)}
            onFocus={() =>
              this.setState({
                text_color_picker: true,
                bg_color_picker: false,
                corner_dropdown: false,
              })
            }
            onBlur={() => this.setState({ text_color_picker: false })}
            fieldLabel="Text color"
            severity={text_color_err ? 'error' : null}
            fieldId="text-color"
            fieldValue={(ctaMods || {}).color}
            isRequired={false}
          />
          <img
            src={rainbowSrc}
            className="picker-icon"
            onClick={() => document.getElementById('text-color').focus()}
          />
          <div className="form-color-picker">
            <ColorPicker
              onClickOutside={() => this.setState({ text_color_picker: false })}
              show={text_color_picker}
              disableAlpha={true}
              presetColors={PRESET_COLORS}
              color={(ctaMods || {}).color}
              onChangeComplete={color =>
                this.handleCtaTextColorInput(color.hex)
              }
            />
          </div>
        </div>
        <div className="dropdown-div">
          <div className="dropdown-corner">
            <Input
              inputClass="new-style"
              onFocus={() =>
                this.setState({
                  text_color_picker: false,
                  bg_color_picker: false,
                  corner_dropdown: true,
                })
              }
              fieldLabel="Button corner style"
              fieldId="button-corner-style"
              fieldType="text"
              fieldValue={this.getBorderRadiusLabel(
                (ctaMods || {}).border_radius
              )}
              isRequired={false}
            />
            <img
              src={corner_dropdown ? dropdownIconRP : dropdownIcon}
              className="dropdown-arrow"
            />
          </div>
          <Dropdown
            show={corner_dropdown}
            outsideClickIgnoreClass="dropdown-corner"
            onClickOutside={() => this.setState({ corner_dropdown: false })}
          >
            <a
              key="1"
              className="dropdown-item"
              onClick={() => this.handleCornerClick(CORNER_STYLE_SQUARED)}
            >
              <img src={sqCorner} className="sq-icon" />
              <div>Square</div>
            </a>
            <a
              key="2"
              className="dropdown-item"
              onClick={() =>
                this.handleCornerClick(CORNER_STYLE_SLIGHTLY_ROUNDED)
              }
            >
              <img src={srCorner} className="sq-icon" />
              <div>Slightly rounded</div>
            </a>
            <a
              key="3"
              className="dropdown-item"
              onClick={() => this.handleCornerClick(CORNER_STYLE_ROUNDED)}
            >
              <img src={rCorner} className="sq-icon" />
              <div>Rounded</div>
            </a>
          </Dropdown>
        </div>
        {ctaEnabled && (
          <div className="delete-cta active" onClick={this.handleDelete}>
            <img src={trashcanE} className="trashcan" />
            <div>Delete CTA</div>
          </div>
        )}
        <div className="cta-buttons">
          <Button
            outerClass="cta-buttons-cancel"
            buttonType="rp-secondary-3"
            value="Cancel"
            onClicked={this.clearSettings}
          />
          <Button
            outerClass="cta-buttons-save"
            buttonType="rp-primary-3"
            disabled={!saveEligible}
            value="Save"
            onClicked={this.save}
          />
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (this.props.videoDuration) {
      this.movePlayerToEnd();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.ctaMods && this.props.ctaMods) {
      this.setState({ button_corner_style: this.props.ctaMods.border_radius });
    }

    if (!prevProps.videoDuration && this.props.videoDuration) {
      this.movePlayerToEnd();
    }
  }

  // move back to the time we moved ahead from
  // to ensure that it is in a good state after being brought back
  // to the previous time, we force the player to play and then
  // pause after a tick so all the right video element events
  // are emitted
  componentWillUnmount() {
    if (this.state.return_to_time) {
      this.props.requestVideoPlayerCurrentTime(this.state.return_to_time);
      this.props.updateVideoPlayerPlaying();
      this.props.requestVideoPlayerPlay();
      setTimeout(() => this.props.requestVideoPlayerPause());

      this.setState({ return_to_time: null });
    }
  }

  // we want to show the actual last frame in the background during preview
  movePlayerToEnd = () => {
    this.setState({ return_to_time: this.props.currentTime });

    this.props.requestVideoPlayerCurrentTime(this.props.videoDuration);
  };

  handleCornerClick = corner => {
    this.setState({ corner_dropdown: false });

    this.handleCtaRadiusInput(corner);
    this.validate();
  };

  getBorderRadiusLabel = radius => {
    switch (radius) {
      case CORNER_STYLE_SQUARED:
        return 'Square';
      case CORNER_STYLE_ROUNDED:
        return 'Rounded';
      case CORNER_STYLE_SLIGHTLY_ROUNDED:
      default:
        return 'Slightly rounded';
    }
  };

  handleCtaBackgroundColorInput = val => {
    const { ctaMods } = this.props;

    this.setState({ background_color_err: false });

    // length longer than hex code length
    if (val.length > 7) {
      return;
    }

    this.props.updateVideoCtaMods({ ...ctaMods, background_color: val });
    this.validate();
  };

  handleCtaTextColorInput = val => {
    const { ctaMods } = this.props;

    this.setState({ text_color_err: false });

    // length longer than hex code length
    if (val.length > 7) {
      return;
    }

    this.props.updateVideoCtaMods({ ...ctaMods, color: val });
    this.validate();
  };

  handleCtaRadiusInput = val => {
    let newVal;

    this.setState({ border_radius_err: false });

    if (!Number.isInteger(Number(val))) {
      return;
    }

    if (val > 200) {
      newVal = 199;
    } else if (val < 0) {
      newVal = 0;
    } else {
      newVal = val;
    }

    const { ctaMods } = this.props;

    this.props.updateVideoCtaMods({ ...ctaMods, border_radius: newVal });
    this.validate();
  };

  handleCtaUrlInput = val => {
    this.setState({ url_err: false });
    this.props.updateVideoCtaUrl(val);
  };

  handleCtaTextInput = val => {
    this.props.updateVideoCtaText(val);
    this.validate();
  };

  saveEligible = () => {
    const { background_color_err, text_color_err, url_err } = this.state;
    const { ctaMods, ctaText, ctaUrl } = this.props;

    // we're eligible to save if there are no errors and the required fields are present
    return (
      !(background_color_err || text_color_err || url_err) &&
      ctaMods &&
      ctaText &&
      ctaUrl
    );
  };

  save = async () => {
    this.instantValidate();

    if (!this.saveEligible()) {
      return;
    }

    const { ctaMods } = this.props;

    await this.props.saveCTA();

    this.props.showConfirmationModal('Call-to-action saved');
    analytics.track(ADD_CUSTOM_VIDEO_CTA_ENABLED, ctaMods || {});
  };

  clearSettings = () => {
    this.props.clearCTAWidgetState();
  };

  handleDelete = async () => {
    this.props.clearCTAWidgetState();

    await this.props.updateVideoCtaCreator();

    this.props.showConfirmationModal('Call-to-action deleted');
  };

  instantValidate = () => {
    const { ctaMods, ctaUrl } = this.props;

    if (ctaMods && ctaMods.color && !isHexColor(ctaMods.color)) {
      this.setState({ text_color_err: true });
    }

    if (
      ctaMods &&
      ctaMods.background_color &&
      !isHexColor(ctaMods.background_color)
    ) {
      this.setState({ background_color_err: true });
    }

    if (
      ctaMods &&
      ctaMods.border_radius &&
      !Number.isInteger(Number(ctaMods.border_radius))
    ) {
      this.setState({ border_radius_err: true });
    }

    if (ctaUrl && !urlRegex({ exact: true, strict: false }).test(ctaUrl)) {
      this.setState({ url_err: true });
    }
  };

  validate = _debounce(this.instantValidate, 300);
}

const mapStateToProps = state => {
  const {
    cta_enabled: ctaEnabled,
    cta_mods: ctaMods,
    cta_text: ctaText,
    cta_url: ctaUrl,
    cta_modal_show: ctaModalShow,
    current_user_is_owner: currentUserIsOwner,
    video,
  } = state.share_video;

  const { duration: videoDuration } = (video && video.video_properties) || {};
  const currentTime = state.video_player.current_time;

  return {
    ctaEnabled,
    ctaMods,
    ctaText,
    ctaUrl,
    ctaModalShow,
    currentUserIsOwner,
    videoDuration,
    currentTime,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateVideoCtaEnabled: enabled => dispatch(updateVideoCtaEnabled(enabled)),
    updateVideoCtaUrl: url => dispatch(updateVideoCtaUrl(url)),
    updateVideoCtaText: text => dispatch(updateVideoCtaText(text)),
    updateVideoCtaMods: mods => dispatch(updateVideoCtaMods(mods)),
    updateVideoCtaCreator: () => dispatch(updateVideoCtaCreator()),
    updateVideoCtaModalShow: show => dispatch(updateVideoCtaModalShow(show)),
    endCTAFlow: () => dispatch(endCTAFlow()),
    requestVideoPlayerCurrentTime: time =>
      dispatch(requestVideoPlayerCurrentTime(time)),
    requestVideoPlayerPlay: () => dispatch(requestVideoPlayerPlay()),
    requestVideoPlayerPause: () => dispatch(requestVideoPlayerPause()),
    updateVideoPlayerPlaying: () => dispatch(updateVideoPlayerPlaying()),
    clearCTAWidgetState: () => dispatch(clearCTAWidgetState()),
    saveCTA: () => dispatch(saveCTA()),
    showConfirmationModal: text => dispatch(showConfirmationModal(text)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTAForm);
